// extracted by mini-css-extract-plugin
export var btn = "main-module--btn--e9609";
export var title = "main-module--title--a5bd9";